import { Modal } from '@/components/common/AppModal';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import FalconCloseButton from '@/components/common/FalconCloseButton';
import { getAiWarningMessage } from '@/app/common/validators/aiMessages';

export const AI_WALLET_INSUFFICIENT_CODE = 209;
const AI_CHARGE_PATH = '/prorogate-or-upgrade/?wallet=500000';

type AiInsufficientBalanceModalProps = {
  show: boolean;
  onHide: () => void;
};

const AiInsufficientBalanceModal = ({
  show,
  onHide
}: AiInsufficientBalanceModalProps) => {
  const navigate = useNavigate();

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header>
        <Modal.Title className="fs-0">اعتبار AI شما کافی نیست</Modal.Title>
        <FalconCloseButton onClick={onHide} />
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="mb-0 fs--1">
          {getAiWarningMessage(AI_WALLET_INSUFFICIENT_CODE)}
        </Alert>
      </Modal.Body>
      <Modal.Footer>
        <Button
          size="sm"
          variant="primary"
          onClick={() => {
            onHide();
            navigate(AI_CHARGE_PATH);
          }}
        >
          شارژ افزونه AI
        </Button>
        <Button size="sm" variant="secondary" onClick={onHide}>
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AiInsufficientBalanceModal;
